import { Card, CardHeader, CardContent } from '../../../components/Card';
import { Button } from '../../../components/Button';
import { Calendar, ChevronLeft, ChevronRight, Filter, Download } from 'lucide-react';

export function GanttChart() {
    return (
        <div className="space-y-6 flex flex-col h-[calc(100vh-8rem)]">
            <div className="flex justify-between items-center shrink-0">
                <div>
                    <h1 className="tracking-tight text-foreground font-display text-page-title">Gantt Chart</h1>
                    <p className="text-muted-foreground">Visual timeline of active projects and tasks.</p>
                </div>
                <div className="flex gap-2">
                    <Button variant="outline">
                        <Filter className="w-4 h-4 mr-2" />
                        Filter
                    </Button>
                    <Button variant="outline">
                        <Download className="w-4 h-4 mr-2" />
                        Export
                    </Button>
                </div>
            </div>

            <Card className="flex-1 flex flex-col min-h-0">
                <CardHeader className="flex flex-row justify-between items-center py-3 shrink-0 border-b border-border">
                    <div className="flex items-center gap-4">
                        <h3 className="text-foreground font-display text-section-title">Q4 Implementation Roadmap</h3>
                    </div>
                    <div className="flex items-center gap-2">
                        <Button variant="outline" size="icon"><ChevronLeft className="w-4 h-4" /></Button>
                        <span className="text-sm font-medium px-2 text-foreground">Oct 2026</span>
                        <Button variant="outline" size="icon"><ChevronRight className="w-4 h-4" /></Button>
                    </div>
                </CardHeader>
                <CardContent className="flex-1 p-0 overflow-auto bg-secondary/10 flex items-center justify-center relative">
                    {/* Placeholder for actual Gantt chart implementation which often uses complex libraries */}
                    <div className="text-center text-muted-foreground max-w-md">
                        <Calendar className="w-12 h-12 mx-auto mb-4 text-primary opacity-20" />
                        <h4 className="text-foreground mb-2 text-sm font-semibold">Gantt Visualization</h4>
                        <p className="text-sm">This view integrates with your Tasks and Projects to display a comprehensive timeline. Add tasks with start and end dates to see them rendered here.</p>
                        
                        <div className="mt-8 grid grid-cols-5 gap-2 opacity-50 pointer-events-none">
                            {/* Mock Gantt Bars */}
                            <div className="col-span-1 text-right pr-2 text-xs font-medium py-1">Design Phase</div>
                            <div className="col-span-4 flex items-center bg-card rounded-r px-2 text-xs border-l border-border relative h-6">
                                <div className="absolute left-4 w-32 h-3 bg-primary rounded-full"></div>
                            </div>
                            
                            <div className="col-span-1 text-right pr-2 text-xs font-medium py-1">Backend Dev</div>
                            <div className="col-span-4 flex items-center bg-card rounded-r px-2 text-xs border-l border-border relative h-6">
                                <div className="absolute left-24 w-48 h-3 bg-warning rounded-full"></div>
                            </div>
                            
                            <div className="col-span-1 text-right pr-2 text-xs font-medium py-1">Frontend Dev</div>
                            <div className="col-span-4 flex items-center bg-card rounded-r px-2 text-xs border-l border-border relative h-6">
                                <div className="absolute left-32 w-64 h-3 bg-success rounded-full"></div>
                            </div>
                            
                            <div className="col-span-1 text-right pr-2 text-xs font-medium py-1">QA & Testing</div>
                            <div className="col-span-4 flex items-center bg-card rounded-r px-2 text-xs border-l border-border relative h-6">
                                <div className="absolute left-80 w-32 h-3 bg-destructive rounded-full"></div>
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
